const UsernameValidation = {
    number: {
        regex: new RegExp('\\d', 'g'),
        should: false,
        errorMsg: 'numbers not allowed'
    },
    letters: {
        regex: new RegExp('[a-zA-Z]{3,}', 'g'),
        should: true,
        //errorMsg: 'please enter min 3 Letters'
    },
    email: {
        regex: new RegExp('@', 'g'),
        should: true,
        errorMsg: '"@" is required'
    },
    emailTopLevel: {
        regex: new RegExp('\.(com|de|at)$', 'g'),
        should: true,
        errorMsg: '".at" or ".com" is required'
    },
    notAllowed: {
        regex: new RegExp('[!"§$%&/()=?`#*+~;,:<>^°]', 'g'),
        should: false,
        errorMsg: 'this {ERROR} are not allowed'
    },
    minAndMaxLetters: {
        regex: new RegExp('.{8,18}', 'g'),
        should: true,
        errorMsg: 'the name musst min 8 Letters'
    },
};


const PasswordValidation = {
    number: {
        regex: new RegExp('[0-9]', 'g'),
        should: true,
        errorMsg: '1 number min required'
    },
    letters: {
        regex: new RegExp('[a-zA-Z]{3,}', 'g'),
        should: true,
        //errorMsg: 'please enter min 3 Letters'
    },
    spezialChar: {
        regex: new RegExp('[!§$%&/=?#*+~@]', 'g'),
        should: true,
        errorMsg: 'please enter min 1 spezial Letters'
    },
    notAllowed: {
        regex: new RegExp('["()`;,:<>]', 'g'),
        should: false,
        errorMsg: 'this {ERROR} are not allowed'
    },
    minAndMaxLetters: {
        regex: new RegExp('.{8,18}', 'g'),
        should: true,
        errorMsg: 'the name musst min 8 Letters'
    },
};



export { UsernameValidation, PasswordValidation };